import { z } from 'zod';

import { PapelEnum } from './enums';
import type { Papel } from './enums';
import type { FeatureKeyEnumType } from './features.dto';

export const LoginInput = z.object({
  email: z.email(),
  senha: z.string().min(1),
});

export type UsuarioOutput = {
  id: string;
  nome: string;
  email: string;
  papel: Papel;
  ativo: boolean;
  professorId: string | null;
};

/** Usuário da sessão, com configurações visuais e features efetivas do tenant (`AuthProvider.hasFeature`). */
export type UsuarioLogadoOutput = UsuarioOutput & {
  nomeEmpresa: string;
  features: FeatureKeyEnumType[];
};

/** O token vai num cookie `HttpOnly`, nunca no corpo. */
export type LoginOutput = {
  usuario: UsuarioLogadoOutput;
};

/** `professorId` é obrigatório para `PROFESSOR`. `ADMIN` também pode ter (administra E dá aula): `requireAdmin` olha `papel`, escrever em registro olha o vínculo. */
export const UsuarioCreateInput = z
  .object({
    nome: z.string().min(1),
    email: z.email(),
    papel: PapelEnum,
    professorId: z.uuid().optional(),
  })
  .refine((data) => data.papel !== 'PROFESSOR' || data.professorId !== undefined, {
    message: 'Selecione o professor que será vinculado a este usuário.',
    path: ['professorId'],
  });

// Sem senha (nasce com placeholder). `papel`/`professorId` só na criação.
export const UsuarioUpdateInput = z
  .object({
    papel: PapelEnum.optional(),
    ativo: z.boolean().optional(),
  })
  .partial();

export const SolicitarResetInput = z.object({
  email: z.email(),
});

export const ResetarSenhaInput = z.object({
  token: z.string().min(1),
  novaSenha: z.string().min(8),
});

export type LoginInputType = z.infer<typeof LoginInput>;
export type UsuarioOutputType = UsuarioOutput;
export type UsuarioLogadoOutputType = UsuarioLogadoOutput;
export type LoginOutputType = LoginOutput;
export type UsuarioCreateInputType = z.infer<typeof UsuarioCreateInput>;
export type UsuarioUpdateInputType = z.infer<typeof UsuarioUpdateInput>;
export type SolicitarResetInputType = z.infer<typeof SolicitarResetInput>;
export type ResetarSenhaInputType = z.infer<typeof ResetarSenhaInput>;
